var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"box__title"},[_vm._v(_vm._s(_vm.$t('pageVisibilitySettings.title')))]),_vm._v(" "),_c('div',[_c('PageVisibilityForm',{attrs:{"default-values":_vm.currentPage},on:{"values-changed":_vm.updatePageVisibility}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }